import React, { useState } from "react";
import { Link } from "react-router-dom";
// import * as Icons from "react-feather";

import { getLocalState } from "../../utils/localStorage";
import { DASHBOARD, LOGIN } from "../../utils/navigation";
import "../../App.css";
// import DropdownMenu from "../../components/DropdownMenu/DropdownMenu";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../../components/ui/navigation-menu";
import {
  Database,
  FileText,
  Gavel,
  Mail,
  Menu,
  User,
  ChevronDown,
  PenTool,
} from "lucide-react";
import { Button } from "../../components/ui/button";
// import NavLogo from "../../components/NavLogo";
import { TooltipProvider } from "../../components/ui/tooltip";
import ServicesDialog from "../../components/ServicesDialog";

const Navbar = () => {
  // const { pathname } = useLocation();
  const currentUser = getLocalState("_currentUser");

  // États pour gérer les dropdowns
  // const [isAPIDropdownOpen, setAPIDropdownOpen] = useState(false);
  // const [isSitesDropdownOpen, setSitesDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Données des menus dropdown
  // const apiMenuItems = [
  //   { label: "API Documentation", link: "#" },
  //   { label: "Developer", link: "#" },
  // ];

  // const sitesMenuItems = [
  //   {
  //     label: "DATAGREFFE JUSTICE",
  //     sub_label: "Décisions de justice",
  //     link: "https://devjustice.datagreffe.ci/",
  //     icon: <Icons.ExternalLink className="w-4 h-4" />,
  //   },
  //   {
  //     label: "DATAGREFFE ENTREPRISE",
  //     sub_label: "Données des entreprises",
  //     link: "https://dev.datagreffe.ci/",
  //     icon: <Icons.ExternalLink className="w-4 h-4" />,
  //   },
  // ];

  const menuItems = [
    {
      label: "Entreprises",
      icon: (
        <Database className="mr-2 transition-transform data-[state=open]:scale-110" />
      ),
      link: "https://dev.datagreffe.ci/",
      description:
        "Accédez à notre base de données complète des entreprises françaises",
    },
    {
      label: "Formalité",
      icon: (
        <FileText className="mr-2 transition-transform data-[state=open]:scale-110" />
      ),
      sublinks: [
        {
          label: "Dépôt d'annonces légales",
          link: "/annonce",
          description: "Publiez vos annonces légales en quelques clics",
        },
        {
          label: "Formalités entreprises",
          link: "/formalite",
          description: "Simplifiez vos démarches administratives",
        },
      ],
    },
    {
      label: "Justice",
      icon: (
        <Gavel className="mr-2 transition-transform data-[state=open]:scale-110" />
      ),
      sublinks: [
        {
          label: "Décisions de justice",
          link: "https://devjustice.datagreffe.ci/",
          description: "Consultez notre base de données de jurisprudence",
        },
      ],
    },
    {
      label: "Toosign",
      icon: (
        <PenTool className="mr-2 transition-transform data-[state=open]:scale-110" />
      ),
      sublinks: [
        {
          label: "Signature électronique",
          link: "https://toosign.com/",
          description:
            "Signez vos documents électroniquement en toute sécurité",
        },
      ],
    },
  ];

  const renderMenuItem = (item) => (
    <NavigationMenuItem key={item.label}>
      <NavigationMenuTrigger className="text-base font-font-semibold">
        {item.icon}
        <span className="text-gray-700 hover:text-orange-500 transition-all duration-300">
          {item.label}
          <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-orange-500 group-data-[state=open]:w-full hover:w-full transition-all duration-300" />
        </span>
      </NavigationMenuTrigger>
      {item.sublinks ? (
        <NavigationMenuContent>
          <ul className="grid w-[500px] gap-3 p-4 bg-white">
            {item.sublinks.map((sublink) => (
              <li key={sublink.label}>
                <Link
                target="_blank"
                  to={sublink.link}
                  className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-orange-50 hover:text-orange-500"
                >
                  <div className="text-sm font-medium leading-none">
                    {sublink.label}
                  </div>
                  <p className="line-clamp-2 text-sm text-muted-foreground">
                    {sublink.description}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </NavigationMenuContent>
      ) : (
        <NavigationMenuContent>
          <ul className="grid w-[400px] gap-3 p-4">
            <li className="row-span-3">
              <Link
                to={item.link}
                className="flex h-full w-full select-none flex-col justify-end rounded-md bg-gradient-to-b from-orange-50 to-orange-100 p-6 no-underline hover:shadow-lg transition-shadow duration-300"
              >
                <div className="mt-4 mb-2 text-lg font-medium text-orange-900">
                  {item.label}
                </div>
                <p className="text-sm leading-tight text-orange-700">
                  {item.description}
                </p>
              </Link>
            </li>
          </ul>
        </NavigationMenuContent>
      )}
    </NavigationMenuItem>
  );

  const renderMobileLink = (item) =>
    item.sublinks ? (
      item.sublinks.map((sublink) => (
        <Link
          key={sublink.label}
          to={sublink.link}
          className="flex items-center text-base font-medium py-2 px-3 hover:bg-orange-50 hover:text-orange-500 rounded-md transition-colors"
        >
          {item.icon} {sublink.label}
        </Link>
      ))
    ) : (
      <Link
        key={item.label}
        to={item.link}
        className="flex items-center text-base font-medium py-2 px-3 hover:bg-orange-50 hover:text-orange-500 rounded-md transition-colors"
      >
        {item.icon} {item.label}
      </Link>
    );

  return (
    <header className="w-full border-b border-gray-100 bg-white shadow-soft sticky top-0 z-50">
      <div className=" mx-lg">
        <div className="flex h-20 items-center justify-around">
          <div className="flex items-center gap-4">
            {/* Logo */}
            <Link to="/">
              <img
                className=" w-20"
                src="/assets/images/logo-recoov.png"
                loading="lazy"
                alt="logo de Datagreffe"
              />
            </Link>

            <div className="hidden lg:flex items-center space-x-2">
              <TooltipProvider>
                <NavigationMenu>
                  <NavigationMenuList>
                    {menuItems.map(renderMenuItem)}
                  </NavigationMenuList>
                </NavigationMenu>
              </TooltipProvider>
            </div>
          </div>

          <div className="flex items-center">
            <a
              href="mailto:contact@datagreffe.ci"
              className="hidden md:flex items-center text-gray-700 hover:text-orange-500 transition-colors mr-4 group"
            >
              <Mail className="mr-2 h-4 w-4 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium">contact@datagreffe.ci</span>
            </a>

            <div className="hidden md:flex items-center gap-2">
              <ServicesDialog
                trigger={
                  <Button
                    variant="outline"
                    className="font-medium text-gray-700 hover:text-orange-500 hover:border-orange-500 hover:bg-orange-50 transition-all duration-300"
                  >
                    Nos Services
                  </Button>
                }
              />
              <Button
                variant="outline"
                className="font-medium text-gray-700 hover:text-orange-500 hover:border-orange-500 hover:bg-orange-50 transition-all duration-300"
              >
                API{" "}
                <ChevronDown className="ml-1 h-4 w-4 transition-transform" />
              </Button>
              <Link
                to={DASHBOARD}
                className="bg-orange-500 text-white text-center py-2 px-3 rounded-md font-medium flex items-center justify-center hover:bg-orange-600 transition-colors transform hover:-translate-y-1 hover:shadow-md duration-300"
              >
                <User className="mr-2 h-5 w-5" />
                {currentUser ? "Accès client" : "Connexion"}
              </Link>
            </div>

            <Button
              variant="ghost"
              className="lg:hidden hover:bg-orange-100 hover:text-orange-500 transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <Menu className="h-6 w-6" />
            </Button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden py-4 px-4 border-t border-gray-100 bg-white">
            <nav className="flex flex-col space-y-4">
              <div className="flex items-center text-base font-medium py-2 px-3 hover:bg-orange-50 hover:text-orange-500 rounded-md transition-colors">
                <Mail className="mr-2 h-5 w-5 text-orange-500" />
                <a
                  href="mailto:contact@datagreffe.ci"
                  className="hover:text-orange-500"
                >
                  contact@datagreffe.ci
                </a>
              </div>
              {menuItems.map(renderMobileLink)}
              <ServicesDialog
                trigger={
                  <div className="flex items-center text-base font-medium py-2 px-3 hover:bg-orange-50 hover:text-orange-500 rounded-md transition-colors">
                    Nos Services
                  </div>
                }
              />
              <Link
                to="#"
                className="flex items-center text-base font-medium py-2 px-3 hover:bg-orange-50 hover:text-orange-500 rounded-md transition-colors"
              >
                API
              </Link>
              <Link
                to={DASHBOARD}
                className="bg-orange-500 text-white text-center py-2 px-3 rounded-md font-medium flex items-center justify-center hover:bg-orange-600 transition-colors transform hover:-translate-y-1 hover:shadow-md duration-300"
              >
                <User className="mr-2 h-5 w-5" />
                {currentUser ? "Accès client" : "Connexion"}
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
